import script from "./ActivityCoupon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityCoupon.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityCoupon.vue?vue&type=style&index=0&id=65b5059f&lang=css"

const __exports__ = script;

export default __exports__